<script setup>
import {ref, useAttrs} from "vue";
import EditToggleButton from "../../Pub/components/EditToggleButton.vue";
import {usePortalContentAndDesignStore} from "../../../../stores/partners/portalContentAndDesignStore";

const portalContentAndDesignStore = usePortalContentAndDesignStore();

const props = defineProps({
    resourceContent: {
        type: Object,
        required: true,
    },
    type: {
        type: String,
        default: 'primary',
    },
    size: {
        type: String,
        default: 'default',
    },
});

const attrs = useAttrs();

const isEditing = ref(false);
const hoverActive = ref(false);

const toggleEdit = () => {
    isEditing.value = !isEditing.value
    if (!isEditing.value) {
        hoverActive.value = false
    }
}
</script>

<template>
<div
    class="relative"
    @mouseenter="hoverActive = true"
    @mouseleave="hoverActive = false"
>
    <edit-toggle-button
        v-show="portalContentAndDesignStore.liveDesignerEnabled && (isEditing || hoverActive)"
        :is-editing="isEditing"
        @toggle="toggleEdit"
        class="transition-opacity duration-200"
    />

    <btn
        v-if="resourceContent.button && resourceContent.url && !isEditing"
        v-bind="attrs"
        type="primary"
        :href="resourceContent.url"
    >
        {{ resourceContent.button }}
    </btn>

    <div v-else class="grid grid-cols-2">
        <div>
            <label
                class="flex justify-between items-center mb-1.5 text-sm">
                Button
            </label>

            <input
                type="text"
                v-model="resourceContent.button"
                placeholder=""
                class="block w-full text-sm rounded border-gray-300 focus:border-gray-400 focus:ring-0"
            />
        </div>

        <div>
            <label
                class="flex justify-between items-center mb-1.5 text-sm">
                URL
            </label>

            <input
                type="text"
                v-model="resourceContent.url"
                placeholder="https://"
                class="block w-full text-sm rounded border-gray-300 focus:border-gray-400 focus:ring-0"
            />
        </div>
    </div>
</div>
</template>
